const API_BASE = import.meta.env.DEV ? '/api' : 'https://api.hyt.re';

async function request<T>(
  path: string,
  options: RequestInit = {}
): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error((data as { error?: string }).error ?? 'Request failed');
  }

  return data as T;
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body?: unknown) =>
    request<T>(path, { method: 'POST', body: body ? JSON.stringify(body) : undefined }),
  delete: <T>(path: string) => request<T>(path, { method: 'DELETE' }),
};

export function apiUrl(path: string): string {
  return `${API_BASE}${path}`;
}

export interface AuthUser {
  id: string;
  email: string;
  email_verified: boolean;
  created_at: string;
}

export interface LicenseInfo {
  id: string;
  status: string;
  active?: boolean;
  bound?: boolean;
  reset_count?: number;
  resets_this_month?: number;
  max_resets_per_month?: number;
  purchased_at: string | null;
}

export interface MeResponse {
  user: AuthUser;
  license: LicenseInfo | null;
}
